import { AllRecipientAndLocalRecipient } from 'features/v2a/sender/helpers/Sender.helpers';
import React, { createContext, ReactNode, useState } from 'react';

interface ConfirmationProps {
  educationMessage?: string;
  headerTitle?: string;
  successMessage?: string;
  ctaTitle?: string;
  amount?: string;
  errorTitle?: string;
  errorMessage?: string;
  isFirstTime?: boolean;
  errorCode?: string;
}

interface V2AContextProps {
  selectedRecipient?: AllRecipientAndLocalRecipient;
  setSelectedRecipient: (recipient?: AllRecipientAndLocalRecipient) => void;
  confirmationData?: ConfirmationProps;
  setConfirmationData: (confirmationData: ConfirmationProps) => void;
}

export const V2AContext = createContext<V2AContextProps>({
  selectedRecipient: undefined,
  setSelectedRecipient: () => {},
  confirmationData: undefined,
  setConfirmationData: () => {},
});

export const V2AContextProvider = ({ children }: { children: ReactNode }) => {
  const [selectedRecipient, setSelectedRecipient] = useState<
    AllRecipientAndLocalRecipient | undefined
  >(undefined);

  const [confirmationData, setConfirmationData] = useState<ConfirmationProps>();

  return (
    <V2AContext.Provider
      value={{
        selectedRecipient,
        setSelectedRecipient,
        confirmationData,
        setConfirmationData,
      }}
    >
      {children}
    </V2AContext.Provider>
  );
};
